import React, { useContext } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FiLogOut, FiLogIn } from "react-icons/fi";


const navLinks = [
  { label: "Dashboard", path: "/admin/dashboard" },
  { label: "Clubs", path: "/admin/clubs" },
  { label: "Sponsors", path: "/admin/sponsors" },
  { label: "Sportsmen", path: "/admin/sportsmen" },
  { label: "Donations", path: "/admin/donations" },
  { label: "Email Templates", path: "/admin/email-templates" },
  { label: "Manage Manual Tokens", path: "/admin/manage-manual-tokens" },
];

const AdminLayout = () => {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  // const handleLogout = () => {
  //   logout(); // Clears context
  //   localStorage.removeItem("token"); // Optional if handled in logout
  //   navigate("/login");
  // };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow-md flex flex-col">
        <div className="p-4 text-xl font-bold border-b">TeamCoin Admin</div>
        <nav className="flex-1 p-4 space-y-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-3 py-2 rounded hover:bg-blue-100 ${
                location.pathname === link.path ? "bg-blue-50 font-semibold text-blue-700" : "text-gray-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="p-4 text-xs text-gray-500 border-t">Logged in as {user?.name || "Admin"}</div>
      </aside>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="p-4 bg-white shadow flex justify-between items-center">
          <span className="text-lg font-medium">Admin Panel</span>

          <div className="flex items-center gap-2">
            {user ? (
              <button
                onClick={() => {
                  logout();
                  localStorage.removeItem("token");
                  localStorage.removeItem("marketToken");
                  window.dispatchEvent(new Event("storage"));
                  navigate("/login");
                }}
                className="ml-4 flex items-center gap-2 px-4 py-1 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-full transition"
              >
                <FiLogOut />
                Abmelden
              </button>
            ) : (
              <Link
                to="/login"
                className="ml-4 flex items-center gap-2 px-4 py-1 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-full transition"
              >
                <FiLogIn />
                Anmelden
              </Link>
            )}
          </div>
        </header>

        <main className="p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
